import AddressPicker from 'components/AddressPicker/AddressPicker';

export default AddressPicker;
